import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { updateActionsErrors } from 'redux/smartchat/details/actions'
import { setAlternativesActionsErrors } from 'redux/smartchat/alternatives/actions'
import OneShotProductViewUI from './OneShotProductViewUI'
import { getDataOptions } from 'components/SmartChatView/utils'

const OneShotProductView = ({ renderType, label, placeholder, dataWay, currentValue, onChange, error }) => {
  const { header, modalActionRef } = useSelector(store => ({
    header: store.smartchatHeader.header,
    modalActionRef: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.modalActionRef
  }), shallowEqual)
  const dispatch = useDispatch()
  const [processesOptions, setProcessesOptions] = useState(null)
  const [value, setValue] = useState({})
  const [dataToExport, setDataToExport] = useState(currentValue || {})
  const [loadingProcessesOptions, setLoadingProcessesOptions] = useState(false)
  const [previewIntegrity, setPreviewIntegrity] = useState({})

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && !processesOptions) getProcessesOptions()

    return () => isSubscribed = false
  }, [])

  // Current data
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!currentValue || !Object.keys(currentValue).length) return

      if (renderType === 'action') {
        if (modalActionRef.mode !== 'update') return
        onChange(currentValue)
      }

      const error = { oneShotProduct: {} }
      const updatedValue = { ...value }
      const updatedPreviewIntegrity = { ...previewIntegrity }

      if (processesOptions) {
        let option = null

        // Found product
        option = processesOptions.find(process => process.value === currentValue.productFoundProcess)
        if (option) {
          if (updatedPreviewIntegrity.productFoundProcess) updatedPreviewIntegrity.productFoundProcess = null
          updatedValue.productFoundProcess = option
        } else {
          // Error
          if (renderType === 'action') {
            if (updatedValue.productFoundProcess !== null) error.oneShotProduct.productFoundProcess = I18n.t('smartchat_tooltip_warning_notFound')
          } else {
            updatedPreviewIntegrity.productFoundProcess = I18n.t('smartchat_tooltip_warning_notFound')
          }
        }

        // Not found product
        option = processesOptions.find(process => process.value === currentValue.productNotFoundProcess)
        if (option) {
          if (updatedPreviewIntegrity.productNotFoundProcess) updatedPreviewIntegrity.productNotFoundProcess = null
          updatedValue.productNotFoundProcess = option
        } else {
          // Error
          if (renderType === 'action') {
            if (updatedValue.productNotFoundProcess !== null) error.oneShotProduct.productNotFoundProcess = I18n.t('smartchat_tooltip_warning_notFound')
          } else {
            updatedPreviewIntegrity.productNotFoundProcess = I18n.t('smartchat_tooltip_warning_notFound')
          }
        }
      }

      // Update local data
      setValue(updatedValue)

      // Error reports
      if (renderType === 'action') {
        if (Object.keys(error.oneShotProduct).length) dataWay?.type === 'alternatives'
          ? dispatch(setAlternativesActionsErrors({ alternativesId: dataWay.alternativesId, actionsErrors: error }))
          : dispatch(updateActionsErrors(error))
      } else {
        if (Object.keys(updatedPreviewIntegrity).length) setPreviewIntegrity(updatedPreviewIntegrity)
      }
    }

    return () => isSubscribed = false
  }, [currentValue, processesOptions])

  const getProcessesOptions = async () => {
    setLoadingProcessesOptions(true)
    try {
      const { processesOptions } = await getDataOptions({ requestedData: ['processesOptions'], params: { headerId: header._id } })
      setProcessesOptions(processesOptions)
    } finally {
      setLoadingProcessesOptions(false)
    }
  }

  const onChangeInner = ({ fieldType, fieldData }) => {
    const updatedValue = { ...value }
    const updatedDataToExport = { ...dataToExport }

    // Data to export
    if (fieldType === 'productFoundProcess' && fieldData) {
      updatedValue.productFoundProcess = fieldData
      updatedDataToExport.productFoundProcess = fieldData.value
    }
    if (fieldType === 'productNotFoundProcess' && fieldData) {
      updatedValue.productNotFoundProcess = fieldData
      updatedDataToExport.productNotFoundProcess = fieldData.value
    }

    // Update local data
    setValue(updatedValue)
    setDataToExport(updatedDataToExport)

    // Export the data
    onChange(updatedDataToExport)
  }

  return (
    <OneShotProductViewUI
      renderType={renderType}
      label={label}
      placeholder={placeholder}
      processesOptions={processesOptions}
      value={value}
      onChangeInner={onChangeInner}
      loadingProcessesOptions={loadingProcessesOptions}
      error={error}
      previewIntegrity={previewIntegrity}
    />
  )
}

export default OneShotProductView
